export default {
  edit: 'Edit',
  environment: 'Environment',
  expanded: 'Expanded',
  export: 'Export'
}
